import { useRef } from 'react';

interface CacheEntry<T> {
  key: string;
  value: T;
  timestamp: number;
}

export const useCalculationCache = <T>(ttlMs: number = 60000) => {
  const cache = useRef<Map<string, CacheEntry<T>>>(new Map());

  const set = (key: string, value: T) => {
    cache.current.set(key, {
      key,
      value,
      timestamp: Date.now(),
    });
  };

  const get = (key: string): T | null => {
    const entry = cache.current.get(key);
    if (!entry) return null;
    
    if (Date.now() - entry.timestamp > ttlMs) {
      cache.current.delete(key);
      return null;
    }
    
    return entry.value;
  };

  const clear = () => {
    cache.current.clear();
  };

  return { get, set, clear };
};

export const createCacheKey = (...args: (string | number | boolean | null | undefined)[]): string => {
  return args.map(arg => String(arg ?? 'null')).join('|');
};